import React from 'react';

const Logo = ({ size = 'default', showText = true }) => {
  const sizes = {
    small: { wrapper: 'w-10 h-10', text: 'text-lg' },
    default: { wrapper: 'w-12 h-12', text: 'text-xl' },
    large: { wrapper: 'w-16 h-16', text: 'text-2xl' },
    hero: { wrapper: 'w-24 h-24', text: 'text-3xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-3">
      <div className={`${s.wrapper} relative`}>
        {/* Main logo circle with gold gradient */}
        <div 
          className="absolute inset-0 rounded-xl"
          style={{
            background: 'linear-gradient(135deg, #D4AF37 0%, #B8962E 100%)',
            boxShadow: '0 4px 15px rgba(212, 175, 55, 0.3)'
          }}
        >
          {/* Inner shine */}
          <div 
            className="absolute inset-0 rounded-xl"
            style={{
              background: 'linear-gradient(135deg, rgba(244, 229, 163, 0.4) 0%, transparent 50%)'
            }}
          />
          
          {/* AI Network Icon */}
          <svg 
            className="absolute inset-0 w-full h-full p-2.5"
            viewBox="0 0 24 24" 
            fill="none"
          >
            {/* Central node */}
            <circle cx="12" cy="12" r="3" fill="white" />
            
            {/* Outer nodes */}
            <circle cx="12" cy="5" r="1.8" fill="white" opacity="0.9" />
            <circle cx="12" cy="19" r="1.8" fill="white" opacity="0.9" />
            <circle cx="5" cy="12" r="1.8" fill="white" opacity="0.9" />
            <circle cx="19" cy="12" r="1.8" fill="white" opacity="0.9" />
            
            {/* Connection lines */}
            <line x1="12" y1="9" x2="12" y2="6.8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="12" y1="15" x2="12" y2="17.2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="9" y1="12" x2="6.8" y2="12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="15" y1="12" x2="17.2" y2="12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
        
        {/* Glow effect */}
        <div 
          className="absolute -inset-1 rounded-xl opacity-30 blur-sm"
          style={{
            background: 'linear-gradient(135deg, #D4AF37, #F4E5A3)'
          }}
        />
      </div>
      
      {showText && (
        <div>
          <h1 
            className={`font-semibold ${s.text}`}
            style={{ 
              fontFamily: 'Cormorant Garamond, serif',
              background: 'linear-gradient(135deg, #D4AF37 0%, #B8962E 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
          >
            MyAiAnalysis
          </h1>
          <p className="text-xs text-gray-400">Database Intelligence</p>
        </div>
      )}
    </div>
  );
};

export default Logo;
